export default {
    install(vue) {
        window.OneSignal = window.OneSignal || [];
        window.OneSignal.push(() => {
            window.OneSignal.init({
                appId: process.env.NODE_ENV !== 'production' ? 'bfa5f285-50fe-4945-9e41-26ddffd0df37' : 'fe0d82e9-59ca-4a14-ba40-152133159d78',
                allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production'
            });
            window.OneSignal.once('notificationDisplay', data => vue.$impressions.sendEvent('app_push_displayed', (data.url.includes('/n/') ? 'news~' : 'recipe~') + data.heading.replace(/\s/gm, '-').toLowerCase(), data.id).catch(console.error));
            window.OneSignal.once('notificationDismiss', data => vue.$impressions.sendEvent('app_push_dismissed', (data.url.includes('/n/') ? 'news~' : 'recipe~') + data.heading.replace(/\s/gm, '-').toLowerCase(), data.id).catch(console.error));
        });
        window.OneSignal.push(["addListenerForNotificationOpened", data => vue.$impressions.sendEvent('app_push_clicked', (data.url.includes('/n/') ? 'news~' : 'recipe~') + data.heading.replace(/\s/gm, '-').toLowerCase(), data.id).catch(console.error)]);

        const ClickWithLoading = () => {

        }

        vue.prototype.$push = {
            ClickWithLoading,
        };
        vue.$push = {
            ClickWithLoading,
        };
    }
}